import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface FilterSheetData {
  availableSeasons: string[];
  availableSizes: string[];
  availableMaterials: Array<{ key: string; name: string; nameEn?: string }>;
  availableColors: Array<{ colorname: string; colorDe?: string | null }>;
  selectedSeasons: Set<string>;
  selectedSizes: Set<string>;
  selectedMaterials: Set<string>;
  selectedColors: Set<string>;
  showTranslations: boolean;
}

@Component({
  selector: 'app-product-filter-sheet',
  templateUrl: './product-filter-sheet.component.html',
  styleUrls: ['./product-filter-sheet.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFilterSheetComponent {
  @Input() availableSeasons: string[] = [];
  @Input() availableSizes: string[] = [];
  @Input() availableMaterials: Array<{ key: string; name: string; nameEn?: string }> = [];
  @Input() availableColors: Array<{ colorname: string; colorDe?: string | null }> = [];
  @Input() selectedSeasons: Set<string> = new Set();
  @Input() selectedSizes: Set<string> = new Set();
  @Input() selectedMaterials: Set<string> = new Set();
  @Input() selectedColors: Set<string> = new Set();
  @Input() showTranslations = false;
  @Input() showDescription = false;
  @Input() showComposition = false;
  @Input() showNameDe = true;

  constructor(private modalCtrl: ModalController, private cdr: ChangeDetectorRef) {}

  toggleDescription() {
    this.showDescription = !this.showDescription;
    this.cdr.markForCheck();
  }

  toggleComposition() {
    this.showComposition = !this.showComposition;
    this.cdr.markForCheck();
  }

  toggleNameDe() {
    this.showNameDe = !this.showNameDe;
    this.cdr.markForCheck();
  }

  get activeFilterCount(): number {
    return this.selectedSeasons.size + this.selectedSizes.size + this.selectedMaterials.size + this.selectedColors.size;
  }

  toggleSeason(season: string) {
    this.selectedSeasons = new Set(this.selectedSeasons);
    if (this.selectedSeasons.has(season)) this.selectedSeasons.delete(season);
    else this.selectedSeasons.add(season);
    this.cdr.markForCheck();
  }

  toggleSize(size: string) {
    this.selectedSizes = new Set(this.selectedSizes);
    if (this.selectedSizes.has(size)) this.selectedSizes.delete(size);
    else this.selectedSizes.add(size);
    this.cdr.markForCheck();
  }

  toggleMaterial(key: string) {
    this.selectedMaterials = new Set(this.selectedMaterials);
    if (this.selectedMaterials.has(key)) this.selectedMaterials.delete(key);
    else this.selectedMaterials.add(key);
    this.cdr.markForCheck();
  }

  toggleColor(colorname: string) {
    this.selectedColors = new Set(this.selectedColors);
    if (this.selectedColors.has(colorname)) this.selectedColors.delete(colorname);
    else this.selectedColors.add(colorname);
    this.cdr.markForCheck();
  }

  reset() {
    this.selectedSeasons = new Set();
    this.selectedSizes = new Set();
    this.selectedMaterials = new Set();
    this.selectedColors = new Set();
    this.cdr.markForCheck();
  }

  apply() {
    this.modalCtrl.dismiss({
      selectedSeasons: this.selectedSeasons,
      selectedSizes: this.selectedSizes,
      selectedMaterials: this.selectedMaterials,
      selectedColors: this.selectedColors,
      showDescription: this.showDescription,
      showComposition: this.showComposition,
    });
  }

  close() {
    this.apply();
  }
}
